import { render, staticRenderFns } from "./CustomerConfigView.vue?vue&type=template&id=cf7fefde&"
import script from "./CustomerConfigView.vue?vue&type=script&lang=js&"
export * from "./CustomerConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports